import * as angular from 'angular';
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.agents')
  .factory('$agentLocation', AgentLocationFactory);

/* @ngInject */
function AgentLocationFactory($bringozFactory: $bringozFactory,
                              agentLocationAPI: BringozApi,
                              Location_DS: DataStoreConfig,
                              Location_PN: PushNotificationsConfig) {
  function $agentLocation(id: string) {
    return $bringozFactory(id, agentLocationAPI, Location_DS, Location_PN);
  }

  return $agentLocation;
}
